import { get, del, post, put } from '../../../../GlobalModules/Utility/Http'
import {
  getRequisitions,
  deleteRequisition,
  createRequisition,
  updateRequisition,
  fetchStoreHierarchy
} from '../Model/RequisitionModel'

export const getRequisitionsApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        colId: item.colId,
        sort: item.sort || 'asc'
      }))
    } else {
      // Default to newest first
      filtersObj.sort = [
        {
          colId: 'id',
          sort: 'desc'
        }
      ]
    }

    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    if (filters.priority) {
      filtersObj.priority = filters.priority
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions`,
      queryParams
    )
    return getRequisitions(response)
  } catch (error) {
    throw error
  }
}

export const deleteRequisitionApi = async (slack) => {
  const response = await del(`${process.env.EXTENDED_URL}procurement/requisitions/${slack}`)
  return deleteRequisition(response)
}

export const createRequisitionApi = async (data) => {
  const response = await post(`${process.env.EXTENDED_URL}procurement/requisitions`, data)
  return createRequisition(response)
}

export const updateRequisitionApi = async (slack, data) => {
  const response = await put(
    `${process.env.EXTENDED_URL}procurement/requisitions/${slack}`,
    data
  )
  return updateRequisition(response)
}

export const fetchStoreHierarchyApi = async (orgId) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}store-hierarchy/organization/${orgId}/hierarchy`)
    return fetchStoreHierarchy(response)
  } catch (error) {
    console.error('Error fetching store hierarchy:', error)
    throw error
  }
}

export const getProductCountApi = async (filters = {}) => {
  try {
    let queryParams = {}
    
    const filtersObj = {
      store_id: localStorage.getItem('store_id')
    }

    // Add date filters if provided
    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions/product-count`,
      queryParams
    )
    
   return response?.data || []
  } catch (error) {
    console.error('Error fetching product count:', error)
    throw error
  }
}

export const loadProductsForRequisitionApi = async (searchKeyword, inventoryFilters = {}, skipSearchFilters = false, limit = 10, offset = 0) => {
  try {
    let queryParams = {}

    const filtersObj = {
      store_id: localStorage.getItem('requisition_store_id') || localStorage.getItem('store_id'),
      own_store: localStorage.getItem('store_id'),
      sort: [{ colId: 'id', sort: 'desc' }],
      is_ingredient: 1,
      status:1
    }

    // Only add search_attr if not skipping search filters
    if (!skipSearchFilters) {
      filtersObj.search_attr = searchKeyword
    }

    // Add inventory filters if provided
    if (inventoryFilters.usage_type) {
      filtersObj.usage_type = inventoryFilters.usage_type
    }
    if (inventoryFilters.inventory_nature) {
      filtersObj.inventory_nature = inventoryFilters.inventory_nature
    }
    if (inventoryFilters.consumption_nature) {
      filtersObj.consumption_nature = inventoryFilters.consumption_nature
    }
    if (inventoryFilters.expiry_tracking) {
      filtersObj.expiry_tracking = inventoryFilters.expiry_tracking
    }
    if (inventoryFilters.batch_tracking) {
      filtersObj.batch_tracking = inventoryFilters.batch_tracking
    }

    // Only add filter_op if not skipping search filters
    if (!skipSearchFilters) {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
    }
    if (limit !== undefined && offset !== undefined && skipSearchFilters) {
      filtersObj.limit = limit
      filtersObj.offset = offset
    }

    queryParams.filters = JSON.stringify(filtersObj)
      
    const response = await get(
      `${process.env.EXTENDED_URL}product/list`,
      queryParams
    )

    const data = response?.data?.data || (Array.isArray(response?.data) ? response.data : [])
    const totalCount = response?.data?.total || 0
    
    // If limit/offset were provided, return object with count
    if (limit !== undefined && offset !== undefined && skipSearchFilters) {
      return {
        data: Array.isArray(data) ? data : [],
        totalCount
      }
    }
    
    return Array.isArray(data) ? data : []
  } catch (error) {
    console.error('Error fetching products:', error)
    if (limit !== undefined && offset !== undefined && skipSearchFilters) {
      return { data: [], totalCount: 0 }
    }
    return []
  }
}

export const loadBillToListApi = async (keywords = '', type = 'SUPPLIER') => {
  try {
    const normalizedType = String(type || 'SUPPLIER').toUpperCase()
    const trimmed = String(keywords || '').trim()
    if (!normalizedType) {
      return []
    }
    // API doesn't allow empty keywords, so use a single space if empty
    const body = {
      keywords: trimmed || ' ',
      type: normalizedType,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_bill_to_list`,
      body
    )
    return response?.data?.data || []
  } catch (err) {
    return []
  }
}

export const getRequisitionApi = async (slack) => {
  const response = await get(`${process.env.EXTENDED_URL}procurement/requisitions/${slack}`)
  return response?.data || { success: false, data: null }
}

export const exportRequisitionsApi = async (data = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      store_id: localStorage.getItem('store_id'),
      download: 'xlsx'
    }

    if (data.search && data.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = data.search
    }

    if (data.from_created_date) {
      filtersObj.from_created_date = data.from_created_date
    }
    if (data.to_created_date) {
      filtersObj.to_created_date = data.to_created_date
    }

    if (data.priority && data.priority !== '') {
      filtersObj.priority = data.priority
    }

    if (data.status != null && data.status !== '') {
      filtersObj.status = data.status
    }

    queryParams.filters = JSON.stringify(filtersObj)

    // Attempt export (backend may return link or raw bytes or base64 data URL)
    const response = await get(
      `${process.env.EXTENDED_URL}report/purchase_requisition`,
      queryParams
    )

    // If API returns a link in JSON
    if (response?.data?.success && response?.data?.link) {
      if (String(response.data.link).startsWith('data:')) {
        const base64Data = response.data.link.split(',')[1]
        const binaryData = atob(base64Data)
        const bytes = new Uint8Array(binaryData.length)
        for (let i = 0; i < binaryData.length; i++)
          bytes[i] = binaryData.charCodeAt(i)
        return {
          success: true,
          data: bytes.buffer,
          message: 'Export completed - converted from base64',
          filename: response.data.filename || 'requisitions_export.xlsx'
        }
      }
      return {
        success: true,
        data: response.data.link,
        message: 'Export completed - file URL provided',
        isFileUrl: true,
        filename: response.data.filename || 'requisitions_export.xlsx'
      }
    }

    // Otherwise return raw data for caller to blob-ify
    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting requisitions:', error)
    throw error
  }
}

export const searchApprovedRequisitionsApi = async (searchKeyword = '') => {
  try {
    let queryParams = {}
    const filtersObj = {
      // limit: 20,
      // offset: 0,
      store_id: localStorage.getItem('store_id'),
      status: [2],
      sort: [{ field: "id", sort: "desc" }]
    }

    if (searchKeyword && searchKeyword.trim() !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = searchKeyword.trim()
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions`,
      queryParams
    )

    const data = response?.data?.data?.data || response?.data?.data || []
    return Array.isArray(data)
      ? data.map((r) => ({
          slack: r.slack,
          requisition_number: r.requisition_number,
          label: `${r.requisition_number}${r.purpose ? ' - ' + r.purpose : ''}`
        }))
      : []
  } catch (error) {
    console.error('Error searching approved requisitions:', error)
    return []
  }
}

export const updateRequisitionStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}procurement/requisitions/status/${slack}`,
      { status }
    )
    return (
      response?.data || { success: false, message: 'Failed to update status' }
    )
  } catch (error) {
    return (
      error?.response?.data || {
        success: false,
        message: 'Failed to update status'
      }
    )
  }
}

/**
 * Get measurement units with optional filters
 * @param {Object} filters - Optional filters for the request
 * @param {boolean} excludeStatusFilter - If true, excludes status:1 filter (used for ProductView)
 * @returns {Promise} List of measurement units
 */
export const getMeasurementUnits = async (filters = {}, excludeStatusFilter = false) => {
  // Default filters as per your requirement
  const defaultFilters = {
    sort: [{ colId: "id", sort: "desc" }]
  };

  // Only add status:1 filter if not excluded
  if (!excludeStatusFilter) {
    defaultFilters.status = 1;
  }

  // Merge default filters with provided filters
  const mergedFilters = { ...defaultFilters, ...filters };

  // Convert filters to query string
  const filtersJson = JSON.stringify(mergedFilters);
  const encodedFilters = encodeURIComponent(filtersJson);

  const response = await get(
    `${process.env.EXTENDED_URL}/measurement_unit?filters=${encodedFilters}`
  );
  return response?.data;
};


export const getRfqSendHistoryApi = async (
  referenceId,
  entityType = 'RFQ',
  searchTerm = '',
  currentPage = 1,
  itemsPerPage = 10,
  storeId
) => {
  try {
    let queryParams = {}

    const filters = {
      limit: itemsPerPage.toString(),
      offset: ((currentPage - 1) * itemsPerPage).toString(),
      store_id: storeId || localStorage.getItem('store_id'),
      reference_id: referenceId,
      sort: [{ colId: 'createdAt', sort: 'desc' }]
    }

    if (searchTerm && searchTerm.length >= 2) {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filters.search_attr = searchTerm
    }

    queryParams.filters = JSON.stringify(filters)
    queryParams.entityType = entityType

    const response = await get(`${process.env.EXTENDED_URL}quotation/history`, queryParams)
    return response?.data || { success: false, data: [] }
  } catch (error) {
    return { success: false, data: [] }
  }
}

export const resendRfqNotificationApi = async (slack) => {
  try {
    const response = await post(`${process.env.EXTENDED_URL}quotation/resend/${slack}`, {})
    return response?.data || { success: false }
  } catch (error) {
    return { success: false }
  }
}

export const getRequisitionAttachmentApi = async (slack) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}procurement/requisitions/file-download/${slack}`)
    return response?.data || { success: false }
  } catch (error) {
    return { success: false }
  }
}

export const getProductAlertApi = async (filters = {}) => {
  try {
    const filtersObj = {
      limit: filters.limit !== undefined ? filters.limit : 10,
      offset: filters.offset || 0,
      sort: filters.sort || [{ colId: 'quantity', sort: 'asc' }],
      store_id: filters.store_id || localStorage.getItem('store_id')
    }

    if (filters.low_stock) {
      filtersObj.low_stock = true
    }
    if (filters.out_of_stock) {
      filtersObj.out_of_stock = true
    }

    const queryParams = {
      filters: JSON.stringify(filtersObj)
    }

    const response = await get(
      `${process.env.EXTENDED_URL}report/productalert`,
      queryParams
    )

    return response?.data || { success: false, data: [] }
  } catch (error) {
    console.error('Error fetching product alerts:', error)
    return { success: false, data: [] }
  }
}

export const getFrequentlyUsedItems = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      store_id: filters.store_id || localStorage.getItem('store_id') || 152
    }

    // Only add limit/offset if explicitly provided
    if (filters.limit !== undefined) {
      filtersObj.limit = filters.limit
    }
    if (filters.offset !== undefined) {
      filtersObj.offset = filters.offset
    }

    // Only add date filters if explicitly provided
    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions/frequently-used-items`,
      queryParams
    )

    return response?.data || { success: false, data: [] }
  } catch (error) {
    console.error('Error fetching frequently used items:', error)
    return { success: false, data: [] }
  }
}
